// extracted by mini-css-extract-plugin
export default {"recommendedSolarComponentOption":"recommended-solar-component-option_recommendedSolarComponentOption__equhf"};